

import React, { useState } from "react";
import axios from "axios";  
import "./forgetpassword.css";

const ForgotPassword = () => {
  const [method, setMethod] = useState(""); 
  const [value, setValue] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!method || !value) {
      alert("Please select a method and enter details!");
      return;
    }

    try {
      const res = await axios.post("https://bodhimaram.onrender.com/api/auth/forgot-password", {
        option: method,  // "email" or "phone"
        value,           // email or phone number
      });

      alert(res.data.message  , res.data.details);

      // Navigate based on method
      if (method === "phone") {
        // Redirect to OTP page
        window.location.href = "/verify-otp";
      } else {
        // For email, they’ll receive a reset link
        alert("Check your email inbox for reset link.");
      }

    } catch (err) {
      console.error(err);
      alert(err.response?.data?.error || "Something went wrong!");
    }
  };

  return (
    <div className="forgot-container">
      <div className="forgot-box">
        <h2>Forgot Password</h2>
        <p>Select how you want to reset your password</p>

        <div className="options">
          <label>           
            Reset via Email         
           <input
              type="radio"
              value="email"
              checked={method === "email"}
              onChange={(e) => setMethod(e.target.value)}
            />
             </label>

          <label>
          Reset via Phone (SMS)
            <input
              type="radio"
              value="phone"
              checked={method === "phone"}
              onChange={(e) => setMethod(e.target.value)}
            />
          </label>
        </div>

        {method && (
          <input
            type={method === "email" ? "email" : "text"}
            placeholder={method === "email" ? "Enter your email" : "Enter your phone number"}
            value={value}
            onChange={(e) => setValue(e.target.value)}
            className="input-field"
          />
        )}

        <button onClick={handleSubmit} className="submit-btn">
          Continue
        </button>
      </div>
    </div>
  );
};

export default ForgotPassword;
